import Index from './index.vue'
export default Index


// WEBPACK FOOTER //
// ./src/pages/Index/index.js